module.exports = __webpack_public_path__ + "static/media/CardAvaible.2b9f3509.svg";